import React, { useState } from 'react';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';
import { testimonials } from '../data/mock';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-20 bg-gray-100">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <span className="text-[#0077B6] font-semibold tracking-wider text-sm uppercase">Client Success</span>
            <h2 className="text-[#0a2342] text-3xl md:text-4xl font-bold mt-2">
              Trusted by<br />
              Industry Leaders<br />
              Across Ontario
            </h2>
          </div>

          {/* Testimonial Card */}
          <div className="relative">
            <div className="bg-white rounded-xl shadow-xl p-8">
              <h4 className="text-[#0a2342] font-bold text-lg mb-1">{currentTestimonial.name}</h4>
              <div className="flex items-center gap-1 mb-2">
                {[...Array(currentTestimonial.rating)].map((_, i) => (
                  <Star key={i} size={16} className="fill-yellow-400 text-yellow-400" />
                ))}
              </div>
              <p className="text-gray-500 text-sm mb-4">{currentTestimonial.company}</p>
              <p className="text-gray-600 leading-relaxed">{currentTestimonial.text}</p>
            </div>

            {/* Navigation Arrows */}
            <div className="absolute left-0 right-0 top-1/2 -translate-y-1/2 flex justify-between pointer-events-none">
              <button
                onClick={prevTestimonial}
                className="w-10 h-10 bg-[#0077B6] rounded-full flex items-center justify-center text-white hover:bg-[#005f8f] transition-colors -translate-x-5 pointer-events-auto shadow-lg"
              >
                <ChevronLeft size={20} />
              </button>
              <button
                onClick={nextTestimonial}
                className="w-10 h-10 bg-[#0077B6] rounded-full flex items-center justify-center text-white hover:bg-[#005f8f] transition-colors translate-x-5 pointer-events-auto shadow-lg"
              >
                <ChevronRight size={20} />
              </button>
            </div>

            {/* Dots */}
            <div className="flex justify-center gap-2 mt-6">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-colors ${index === currentIndex ? 'bg-[#0077B6]' : 'bg-gray-300'}`}
                />
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Text */}
        <p className="text-center text-gray-500 mt-12 max-w-2xl mx-auto">
          Building lasting partnerships through exceptional service delivery and measurable business outcomes.
        </p>
      </div>
    </section>
  );
};

export default Testimonials;
